'use client';

import { useTranslation } from 'react-i18next';

import { Button } from '@/components/buttons';
import { ImageComponent } from '@/components/Image';
import { Modals } from '@/helpers/modals';
import { useModalsStore } from '@/store';

export const GameErrorNotAuthDesktop = () => {
  const { t } = useTranslation('common');
  const open = useModalsStore.use.open();

  return (
    <>
      <ImageComponent
        alt="door-img"
        height={80}
        src="/game/oops-door.webp"
        width={80}
      />
      <h2 className="error-title">{t('game.notLoggedIn')}</h2>
      <p className="error-subtitle">{t('game.loginToPlay')}</p>
      <div className="not-auth-buttons">
        <Button onClick={() => open(Modals.Login)} secondary>
          {t('button.login')}
        </Button>
        <Button onClick={() => open(Modals.Registration)} primary>
          {t('button.signUp')}
        </Button>
      </div>
    </>
  );
};
